import { Lang } from 'Roblox';
import angular from 'angular';

const avatar = angular
  .module('avatar', [
    'robloxApp',
    'cursorPagination',
    'recommendations',
    'modal',
    'thumbnails',
    'thumbnails3d',
    'toast',
    'infiniteScroll'
  ])
  .config([
    '$injector',
    $injector => {
      // conditionally include the languageResourceProvider
      if (Lang.AvatarResources) {
        const languageResourceProvider = $injector.get('languageResourceProvider');
        languageResourceProvider.setLanguageKeysFromFile(Lang.AvatarResources);
      }
    }
  ]);

export default avatar;
